// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrometheusChartsController = function ($scope, $routeParams, PrometheusLog, PrometheusAction) {

    const DEFAULT_ACTIONS_TO_REQUEST = ["ActionProcessRecurring", "ActionProcessPayments", "ActionProcessEscalations"];
    $scope.dateFrom = moment().subtract(7, 'days').toISOString(true);
    $scope.dateTo = moment().toISOString(true);
    $scope.actionNames = $routeParams.actionName ? $routeParams.actionName : null;
    $scope.isLoading = true;
    $scope.isCheckboxesExpanded = false;

    let selectedActions = $routeParams.actionName ? $routeParams.actionName : DEFAULT_ACTIONS_TO_REQUEST;
    let dateFormat = '';

    PrometheusAction.getNames(function(data) { $scope.actionNames = data.map(x => x.Name);});

    let getDateFormat = function(startDate, endDate)
    {
        let dateDifference =  moment.duration(moment(endDate).diff(moment(startDate)));

        if (dateDifference.asDays() >= 2)
            return '%m-%d-%Y';

        if(dateDifference.asHours() >= 1)
            return '%m-%d-%Y %H:%M';

        return '%m-%d-%Y %H:%M:%S';
    }

    $scope.stats = {
        data: [],
        charts: {           
            actionsLogs: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.time.format(dateFormat)(new Date(d * 1000));
                    }
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    }
                }
            }
        }
    };
    
    $scope.clickApply = function(){
        $scope.isCheckboxesExpanded = false;
        $scope.isLoading = true;
        $scope.loadLogs();
    }

    $scope.loadLogs = function () {
        var data = PrometheusLog.query({ 
                dateFrom: $scope.dateFrom,
                dateTo: $scope.dateTo,
                actionNames : selectedActions
            }, 
            function () {
            
            dateFormat = getDateFormat($scope.dateFrom, $scope.dateTo);
            var chartValues = [];    
    
            for (var i = 0; i < data.length; i++) {
                var currentAction = data[i];
                var executions = [];
                var maxExecutions = [];
                for (var j = 0; j < currentAction.Executions.length; j++)
                {
                    maxExecutions.push([new Date(currentAction.Executions[j].StartTimeEpoch), currentAction.Executions[j].MaxExecutionTime ]);
                    executions.push([new Date(currentAction.Executions[j].StartTimeEpoch), currentAction.Executions[j].ExecutionTime ]);
                }
                chartValues.push({key: data[i].ActionName, values: executions});
                chartValues.push({key: data[i].ActionName+" (maximums)", values: maxExecutions});
            }
    
            $scope.stats.charts.actionsLogs.data = chartValues;

            $scope.isLoading = false;
    
        }, 
        function () {
          
            $scope.isLoading = false;
            $scope.stats.charts.actionsLogs.data = [];
    
        });
    }
    
    $scope.expandCheckboxes = function()
    {
        $scope.isCheckboxesExpanded = !$scope.isCheckboxesExpanded;
    }

    $scope.isActionChecked = function(actionName)
    {
        return selectedActions.includes(actionName);
    }

    $scope.clickActionCheckbox = function(actionName)
    {
        if(selectedActions.includes(actionName))
        {
            selectedActions = selectedActions.filter(function(value, index, arr){ 
                return value != actionName });
        }
        else
        {
            selectedActions.push(actionName);
        }
    }

    $scope.toolTipContentFunction = function(){
        return function(key, x, y, e, graph) {
            return  key +
                '<p>' +  y + 'ms  at ' + x + '</p>'
        }
    }

    $scope.loadLogs();
    
};
PrometheusChartsController.$inject = ['$scope', '$routeParams', 'PrometheusLog', 'PrometheusAction'];
